const SET_ORDER = 'SET_ORDER';
const SET_ENABLEORDERTRACKING = 'SET_ENABLEORDERTRACKING';
const SET_ENABLEDROPSHIPFLAG = 'SET_ENABLEDROPSHIP';
const SET_SHOWRETURNABLE = 'SET_SHOWRETURNABLE';
const SET_ENABLEPARTORDERING = 'SET_ENABLEPARTORDERING';

export {
    SET_ORDER,
    SET_ENABLEORDERTRACKING,
    SET_ENABLEDROPSHIPFLAG,
    SET_SHOWRETURNABLE,
    SET_ENABLEPARTORDERING
};